import { render, staticRenderFns } from "./ReleasesDraft.vue?vue&type=template&id=32796916&"
import script from "./ReleasesDraft.vue?vue&type=script&lang=js&"
export * from "./ReleasesDraft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports